import { Button } from './ui/button';
import { LogOut, Shield } from 'lucide-react';

const ImpersonationBanner = () => {
  const impData = sessionStorage.getItem('impersonating');
  if (!impData) return null;

  let companyName, adminName;
  try {
    ({ companyName, adminName } = JSON.parse(impData));
  } catch {
    return null;
  }

  const handleExit = () => {
    const saToken = sessionStorage.getItem('superAdminToken');
    if (saToken) {
      sessionStorage.setItem('token', saToken);
      sessionStorage.removeItem('superAdminToken');
      sessionStorage.removeItem('superAdminUser');
      sessionStorage.removeItem('impersonating');
      window.location.href = '/companies';
    }
  };

  return (
    <div className="bg-emerald-600 text-white px-4 py-2 flex items-center justify-between text-sm" data-testid="impersonation-banner">
      <div className="flex items-center gap-2">
        <Shield className="w-4 h-4" />
        <span>Viewing as <strong>{adminName}</strong> ({companyName}) — Super Admin Impersonation Mode</span>
      </div>
      <Button onClick={handleExit} variant="outline" size="sm" className="text-white border-white hover:bg-emerald-700 gap-1" data-testid="exit-impersonation">
        <LogOut className="w-3 h-3" /> Exit
      </Button>
    </div>
  );
};

export default ImpersonationBanner;
